<div class="mt no-hor-scroll">
  <vpfa-mobile-action-button (click)="closeAction.emit()">
    {{ 'uniqueData.back' | translate }}
  </vpfa-mobile-action-button>
</div>

